import { render, staticRenderFns } from "./ReturnShipmentErrorReport.vue?vue&type=template&id=9b890020"
import script from "./ReturnShipmentErrorReport.vue?vue&type=script&lang=js"
export * from "./ReturnShipmentErrorReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports